import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../../CustomModal";

const CourseCertificatesModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const certificates = [
    {
      id: 1,
      title: t("React Basics Course"),
      image: "/certificates/react-basics.png",
    },
    {
      id: 2,
      title: t("Advanced JavaScript"),
      image: "/certificates/advanced-js.png",
    },
    {
      id: 3,
      title: t("UI/UX Design Principles"),
      image: "/certificates/uiux-design.png",
    },
  ];

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleCloseModal}
      className="max-w-[50rem] rounded-3xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
      contentClassname="p-6 bg-[#F1F1F1] px-0"
    >
      <div className="p-4">
        <h2 className="mb-4 text-center text-2xl font-bold">{t("Your Gained Certificates")}</h2>

        <div className="flex flex-wrap justify-center gap-6">
          {certificates.map((certificate) => (
            <div key={certificate.id} className="flex flex-col items-center rounded-lg border p-4 shadow-md">
              <img
                src={certificate.image}
                alt={certificate.title}
                className="h-40 w-64 rounded-lg object-cover"
              />
              <h3 className="mt-3 text-center text-lg font-semibold">{certificate.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </CustomModal>
  );
});

export default CourseCertificatesModal;
